import React from "react";

const RequiredPrivacyTerms = () => {
  return (
    <div className="content">
      <p>
        주식회사 아이나비시스템즈(이하 "회사"라 함)는 고객님의 개인정보를 매우
        중요시하며 고객님이 INAVI Maps 서비스를 이용하기 위해 제공한 개인정보를
        안전하게 관리하고 보호할 수 있도록 최선을 다하고 있습니다.
      </p>
      <p>
        회사는 INAVI Maps 서비스를 이용함에 있어, 원활한 서비스 이용 및 편리하고
        유익한 정보를 제공하기 위하여 아래와 같이 개인정보를 수집합니다.
      </p>
      <table>
        <tbody>
          <tr>
            <td width="141">
              <p>
                <strong>수집/이용 목적</strong>
              </p>
            </td>
            <td width="312">
              <p>
                <strong>개인정보 항목</strong>
              </p>
            </td>
            <td width="148">
              <p>
                <strong>보유기간</strong>
              </p>
            </td>
          </tr>
          <tr>
            <td width="141">
              <p>회원가입 및 고객식별</p>
            </td>
            <td width="312">
              <p>① 개인회원 : 계정, 이름, 연락처</p>
              <p>
                ② 사업자회원 : 회원 정보(계정, 이름, 연락처), 담당자 정보(담당자
                연락처), 사업자 정보(사업자명, 사업자 번호, 업태, 종목, 주소,
                사업자 등록증, 대표자명, 대표 사업자 이메일)
              </p>
            </td>
            <td rowSpan="4" width="148">
              <p>서비스의 이용 종료 시 까지 보유</p>
            </td>
          </tr>
          <tr>
            <td width="141">
              <p>SNS ID 계정연동</p>
            </td>
            <td width="312">
              <p>① Naver : 이름, 이메일 주소, 전화번호</p>
              <p>② Google : 이름, 이메일 주소, 전화번호</p>
              <p>
                ③ kakao : 프로필정보(닉네임/프로필사진), 카카오계정(이메일),
                전화번호
              </p>
            </td>
          </tr>
          <tr>
            <td width="141">
              <p>개발 문의</p>
            </td>
            <td width="312">
              <p>이름, 이메일, 문의 내용</p>
            </td>
          </tr>
          <tr>
            <td width="141">
              <p>1:1 문의</p>
            </td>
            <td width="312">
              <p>이름, 회사(기관명), 연락처, 이메일</p>
            </td>
          </tr>
        </tbody>
      </table>
      <p>&nbsp;</p>
      <p>
        INAVI Maps 서비스 이용을 위한 최소한의 정보를 수집하고 있으므로 동의를
        거부하시는 경우 서비스가 제한됩니다. 자세한 사항은 회사의{" "}
        <u>개인정보처리방침(</u>
        <u>&egrave;</u>
        <u>링크)</u>을 참고해 주시기 바랍니다.
      </p>
    </div>
  );
};

export default RequiredPrivacyTerms;
